import React from 'react';

type Props = {
  className?: string;
};

const Step3: React.FC<Props> = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="none" viewBox="0 0 36 36">
    <path
      fill="#000"
      d="M17.788 25.216a10.19 10.19 0 01-2.61-.342c-.864-.24-1.596-.576-2.196-1.008l1.134-2.232c.48.348 1.038.624 1.674.828a6.272 6.272 0 001.926.306c.732 0 1.308-.144 1.728-.432.42-.288.63-.684.63-1.188 0-.48-.186-.858-.558-1.134-.372-.276-.972-.414-1.8-.414h-1.332v-1.926l3.51-3.978.324 1.044h-6.606V12.4h8.82v1.89l-3.492 3.978-1.476-.846h.846c1.548 0 2.718.348 3.51 1.044.792.696 1.188 1.59 1.188 2.682 0 .708-.186 1.374-.558 1.998-.372.612-.942 1.11-1.71 1.494-.768.384-1.752.576-2.952.576z"
    ></path>
    <circle cx="18" cy="18" r="17" stroke="#000" strokeWidth="2"></circle>
  </svg>
);

export default Step3;
